import React, { useEffect, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import _ from 'lodash';
import styles from './index.module.scss';
import { DATE_FORMATS, formatDate } from 'utils';

const propsEqual = (prevProps, nextProps) => {
  return _.isEqual(prevProps, nextProps);
};

const RouteInfoTooltip = props => {
  const [tooltipData, setTooltipData] = useState<Record<string,any>>({});
  
  useEffect(() => {
    setTooltipData(props.routeInfo);
  }, []);

  
  const getToolTip = () => (
    <div className={styles['route-tooltip']}>
      {!tooltipData ? (
        <div>No Route Found</div>
      ) : (
        <>
          <div className={styles['column-section']}>
            <div className={styles['route-info-group']}>
              <div>Route ID</div>
              <div>{tooltipData.objectId}</div>
            </div>
            <div className={styles['route-info-group']}>
              <div>Route Name</div>
              <div>{tooltipData.name}</div>
            </div>
            <div className={styles['route-info-group']}>
              <div>Created On</div>
              <div>{formatDate(tooltipData.createdAt, DATE_FORMATS.MM_DD_YYYY_hh_mm_A)}</div>
            </div>
            <div className={styles['route-info-group']}>
              <div>Comment</div>
              <div>{tooltipData.comment || '-'}</div>
            </div>
          </div>
          <div className={styles['column-section']}>
            <div className={styles['route-info-group']}>
              <div>Status</div>
              <div>{tooltipData.status}</div>
            </div>
            <div className={styles['route-info-group']}>
              <div>Locked</div>
              <div>{tooltipData.locked?.toString()}</div>
            </div>
            <div className={styles['route-info-group']}>
              <div>Delivery Date</div>
              <div>
                {tooltipData.deliveryDateTime ? (
                  formatDate(tooltipData.deliveryDateTime, DATE_FORMATS.MM_DD_YYYY)
                ) : (
                  '-'
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
  
  return (
    <>
      <ReactTooltip
        id={'route-detail'}
        multiline={true}
        getContent={() => getToolTip()}
        place={'left'}
        type={'dark'}
        effect={'solid'}
        globalEventOff={'click'}
        afterHide={props.hideToolTip}
      />
    </>
  );
};

export default React.memo(RouteInfoTooltip, propsEqual);